import { styled, Tab } from '@mui/material';

export const TabStyled = styled(Tab)({
  // reset min-height to state without icons
  minHeight: 48,
}) as typeof Tab;
